import {
    memo
} from "react";
import {
    useWindowDimensions,
    View
} from "react-native";
import type CompanyFiltersProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    SelectBox,
    TextInput
} from "ncore-ui-kit";
import {
    SearchIcon
} from "lucide-react-native";

const CompanyFilters = ({
    setSectorFilters,
    setSearchQuery,
    sectorFilters,
    searchQuery,
    sectorData
}: CompanyFiltersProps) => {
    const {
        width
    } = useWindowDimensions();
    const isMobile = width < 992;

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const {
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const initialSelectedSectors = sectorFilters.map(filterValue => {
        const sector = sectorData.find(s => s.value === filterValue);
        return sector ? {
            __title: sector.title,
            title: sector.title,
            value: sector.value,
            __key: sector.value
        } : null;
    }).filter(Boolean) as Array<{
        __title: string;
        __key: string;
        title: string;
        value: string;
    }>;

    return <View
        style={[
            stylesheet.filterSection,
            {
                alignItems: isMobile ? "stretch" : "flex-end",
                flexDirection: isMobile ? "column" : "row",
                marginTop: spaces.spacingLg,
                gap: spaces.spacingMd
            }
        ]}
    >
        <View
            style={[
                stylesheet.searchContainer,
                isMobile && {
                    width: "100%"
                }
            ]}
        >
            <TextInput
                placeholder={localize("companies-search-placeholder")}
                customColor={colors.project.brandWhite}
                icon={({
                    color,
                    size
                }) => <SearchIcon
                    color={colors.content.icon[color]}
                    size={size}
                />}
                onChangeText={setSearchQuery}
                spreadBehaviour="stretch"
                value={searchQuery}
            />
        </View>
        <View
            style={[
                stylesheet.filterDropdownContainer,
                {
                    width: isMobile ? "100%" : 220
                }
            ]}
        >
            <SelectBox
                onChange={selectedItems => {
                    setSectorFilters(selectedItems.map(item => item.__key as string));
                }}
                placeholder={localize("companies-sector-select")}
                initialSelectedItems={initialSelectedSectors}
                title={localize("companies-sector-select")}
                key={`sector-filter-${sectorData.length}`}
                customTheme={{
                    themeKey: "events_filter" as never
                }}
                titleExtractor={item => item.title}
                keyExtractor={item => item.value}
                spreadBehaviour="stretch"
                isMultipleSelect={true}
                data={sectorData}
                maxChoice={-1}
            />
        </View>
    </View>;
};

export default memo(CompanyFilters);
